const formstackFormPickerValidation = value => {
	// can only pass validation if it has 4 values in object:
	const hasIntegrationId = value.hasOwnProperty("oauthIntegrationId");
	const hasFormstackId = value.hasOwnProperty("formstackFormId");
	const hasRefreshedAt = value.hasOwnProperty("refreshedAt");
	const hasFormData = value.hasOwnProperty("formData");

	if (!hasIntegrationId) return "Need to pick an OAuth Integration";
	if (!hasFormstackId) return "Need to pick a Formstack form";
	if (!hasRefreshedAt) return "Unable to find the last time this form was refreshed";
	if (!hasFormData) return "No form data found";

	return null;
};

export default formstackFormPickerValidation;
